const headerPopup = document.getElementById('header-popup');
const headerPopupCloseButton = document.getElementById('header-popup__close-button');
const headerPopupInner = document.getElementById('header-popup__inner');
const headerPopupTrigger = document.getElementById('header-popup-trigger');

if (headerPopup) {
  headerPopup.addEventListener('close', function () {
    document.body.classList.remove('prevent-scroll');
  });
}

if (headerPopupTrigger) {
  headerPopupTrigger.addEventListener('click', function () {
    headerPopup.showModal();

    document.body.classList.add('prevent-scroll');
  });

  document.addEventListener('click', function (event) {
    if (headerPopup.open && !headerPopupInner.contains(event.target) && !headerPopupTrigger.contains(event.target)) {
      headerPopup.close();
    }
  });
}

if (headerPopupCloseButton) {
  headerPopupCloseButton.addEventListener('click', function () {
    headerPopup.close();
  });
}
